<template>
  <div style="width: 100%;height: 100%;">
    <div style="float: left;margin-bottom: 20px">
      <span>查询单号：</span>
      <a-select v-model="order" filterable placeholder="请选择单号" :clearable="true">
        <a-select-option
          v-for="item in locations"
          :key="item.id"
          :label="item.order"
          :value="item.order">
        </a-select-option>
      </a-select>
    </div>
    <gaode-map style="width:100%;height:750px;border:1px solid gray;"></gaode-map>
  </div>
</template>

<script>

  import GaodeMap from '../components/GaodeMap.vue'


  export default {
    name: 'Gps',
    components: {
      GaodeMap,
    },
    data() {
      return {
        Clng: "120.267842",
        Clat: "30.19439",
        Flng: "120.267417907715",
        Flat: "30.19460105896",
        Tlng: "120.269302368164",
        Tlat: "30.2087898254395",
        path: [{lnglat: [116.303843, 39.983412]}, {lnglat: [116.321354, 39.896436]}, {lnglat: [116.407012, 39.992093]}],
        from: null,
        to: null,
        middle: null,
        input: '',
        order: '',
        locations: [{
          id: 1,
          order: '773005139323692',
          start: {
            lng: 117.26542,
            lat: 39.112487,
          },
          middle: {
            lng: 117.213246,
            lat: 39.096892,
          },
          end: {
            lng: 117.174799,
            lat: 39.105852,
          },
          totalTime: 5,
          nowTime: 3,
        }, {
          id: 2,
          order: '771101649406458',
          start: {
            lng: 117.245221,
            lat: 31.922786,
          },
          middle: {
            lng: 106.721591,
            lat: 29.682765,
          },
          end: {
            lng: 102.815557,
            lat: 34.985875,
          },
          totalTime: 3,
          nowTime: 1,
        }],
      };
    },
    created() {
    },
    mounted() {
    },
    methods: {},
  };

</script>

<style scoped>


</style>
<style>
  .amap-marker-label {
    /*border-radius: 30px;*/
    border: none;
    left: 7px !important;
  }
</style>
